declare namespace $ {

	export class $mol_icon_format_size extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=size.view.tree.d.ts.map